<template>
  <div>
    <div class="flex-wrap" :class="isUnRead(itemData) ? `priority-${itemData.priority}` : '' ">
      <div class="red-point-wrap">
        <span
          v-if="isUnRead(itemData)"
          class="red-point" 
        ></span>
      </div>
      <div style="flex: 1">
        <div class="title-wrap">
          <div class="item-title" :title="isZh ? itemData.titleCn : itemData.titlee">
            {{ isZh ? itemData.titleCn : itemData.title }}
          </div>
  
          <div class="item-dur">{{ itemData.createTime }}</div>
        </div>

        <div class="item-content" :title="isZh ? itemData.contentCn : itemData.content">
          {{ isZh ? itemData.contentCn : itemData.content }}
      </div>
        <!-- // 1-message  2-todo -->
        <div class="item-ops" v-if="msgType == 2">
          <lls-button 
            type="primary" 
            :disabled="!isUnRead(itemData)">
            {{ $t('message.done') }}
          </lls-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isUnRead } from '../func.js'

export default {
  props: {
    itemData: {
      type: Object,
      default: () => {}
    },
    msgType: { // 0-Message 1-todo
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      dialogVisible: false,
      isZh: this.$i18n.locale == 'zh'
    }
  },
  methods: {
    isUnRead() {
      const a = isUnRead(...arguments, this.msgType)

      return a
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.flex-wrap {
  position: relative;
  display: flex;
  padding: 24px;
  gap: 4px;
  color: #4A4A4A;
  line-height: 18px;
  border-bottom: 1px solid #E2E8F0;
  cursor: pointer;
  &::before{
    content: '';
    background-color: #fff;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 8px;
  }
}
.red-point-wrap {
  flex: 0 0 6px;
}
.red-point {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}
.item-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.item-content {
  font-size: 14px;
  line-height: 20px;
  color: #4A4A4ACC;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
}
.item-dur {
  font-size: 12px;
  white-space: nowrap;
}
.item-ops {
  margin-top: 12px;
}
.title-wrap{
  display: flex; 
  justify-content: space-between; 
  gap: 10px
}
.priority-1 {
  background: #F76C5E0D;
  &::before{
    content: '';
    background-color: #F76C5E80;
  }
  .red-point {
    background-color: #F76C5E;
  }
}
.priority-2,.priority-3 {
  background: #5A9CF80D;
  &::before{
    content: '';
    background-color: #5A9CF880;
  }
  .red-point {
    background-color: #4E78B1 ;
  }
}
.item-dur {
  color: #475569;
  font-size: 12px;
}

</style>